
export function formatCurrency(amount: number, currencyCode: string): string {
	// Todo: If we implement localization, we can use the user's preferred locale
	// to format the currency correctly.
	// For now, we will use the default locale of the browser.
	// This will use the browser's default locale, which is usually the user's locale.
	return new Intl.NumberFormat(undefined, {
		style: 'currency',
		currency: currencyCode,
		currencyDisplay: 'narrowSymbol',
		minimumFractionDigits: 0,
		maximumFractionDigits: 2
	}).format(amount);
}
